import '@swc/helpers';
import 'react';
import '@grandvisionhq/state';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import '../../../../types/product.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import '../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../operations/queries/get-frames-by-slug.js';
import '../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '@grandvisionhq/utils';
import '../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/forms';
import '@grandvisionhq/analytics';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/inventory';
import '@grandvisionhq/lib-utils-html';
import '../../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-visuals';
import '../../../../slots/context.js';
import '@grandvisionhq/content';
import { useCLEcommContext } from '../context/CLEcommContext.js';

const useIsCLDeliveryIndicatorReady = ()=>{
    const { state , selectors  } = useCLEcommContext();
    const lineItemDrafts = selectors.getLineItemDrafts(state);
    // If ther user has not yet configured a prescription, then there are no line items
    // and the USP-type delivery indicator is not ready to show a delivery estimate
    return lineItemDrafts.length > 0;
};

export { useIsCLDeliveryIndicatorReady };
//# sourceMappingURL=use-is-cl-delivery-indicator-ready.js.map
